import {DomainEvent} from './DomainEvent';
import {Match} from '../resources/Match';

export class MatchShifted extends DomainEvent<Match> {}
